import {ForecastMapScalarMeta} from '../../api/types';

// Encode curves this client knows how to turn back into values. The
// backend records the curve per run (`scalar_meta.encode`); runs
// predating the field are linear by construction.
export type ScalarTextureEncode = 'linear' | 'sqrt';

/**
 * The meta's encode curve, or null when this build does not implement
 * it. Never map an unknown curve onto 'linear': decoding a non-linear
 * texture linearly renders wrong values everywhere.
 */
export const scalarTextureEncode = (
  meta: ForecastMapScalarMeta,
): ScalarTextureEncode | null => {
  const encode = meta.encode ?? 'linear';
  return encode === 'linear' || encode === 'sqrt' ? encode : null;
};

/**
 * Forward-compat gate for the manifest's scalar block: a run declaring
 * an encode curve this build cannot decode behaves as if it shipped no
 * textures at all, so the screen falls back to the overlay path.
 */
export const decodableScalarMeta = (
  scalar: ForecastMapScalarMeta | null,
): ForecastMapScalarMeta | null =>
  scalar !== null && scalarTextureEncode(scalar) !== null ? scalar : null;
